// utils/updateStatus.js

import axios from "axios";
import swal from "sweetalert";

const api_path = process.env.REACT_APP_API_URL;

export const updateStatus = async ({ JOB_ID,JOB_TYPE, STATUS, REMARK = "", REASON_ID = "", REASON_NAME = "", USER_ID }) => {
   console.log("updateStatus payload:", { JOB_ID, JOB_TYPE, STATUS, USER_ID });
  try {
    const res = await fetch(`${api_path}/customer/updateCustomerRegisterStatus.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
     body: JSON.stringify({
      JOB_ID: JOB_ID,        
      JOB_TYPE: JOB_TYPE,  
      STATUS: STATUS,      
      USER_ID: USER_ID,    
      REMARK: REMARK,
      REASON_ID: REASON_ID,
      REASON_NAME: REASON_NAME,
    }),
    });

    const result = await res.json();

    if (result.status == "200") {
      await swal("Done.", "Save data successfully.", "success", {
        buttons: true,
        timer: 5000,
      });

      axios.get(
        `${api_path}/sendmail_customer_new.php?id=${JOB_ID}&status=${STATUS}`
      ).catch(() => {});

      window.location.href = `./CustomerRegisterDetail?id=${JOB_ID}&type=${JOB_TYPE}`;
      return { success: true };

    } else {
      swal("Sorry", result.message, "error", {
        buttons: true,
        timer: 10000,
      });
      return { success: false, message: result.message };
    }

  } catch (error) {
    console.error(error);
    swal("Error", "Something went wrong", "error");
    return { success: false, message: error.message };
  }
};